export default {
    feedDetail(state) {
        return state.feedDetail;
    }
}